interface ContactedMember {
  first_name: string;
  last_name: string;
  sso_uuid: string;
  cropped_photo_url: string | null;
  profile_photo_status: string;
}

interface CloseTheLoopInterface {
  hasActiveIapSubscription: boolean;
  hasCanceledSubscription: boolean;
  isWinBackEligible: boolean;
  contactedMembers: ContactedMember[];
}

export default class CloseTheLoop {
  hasActiveIapSubscription: boolean;

  hasCanceledSubscription: boolean;

  isWinBackEligible: boolean = true;

  contactedMembers: ContactedMember[];

  constructor({ hasActiveIapSubscription, hasCanceledSubscription, contactedMembers, isWinBackEligible }: CloseTheLoopInterface) {
    this.hasActiveIapSubscription = hasActiveIapSubscription;
    this.hasCanceledSubscription = hasCanceledSubscription;
    this.isWinBackEligible = isWinBackEligible;
    this.contactedMembers = contactedMembers;
  }
}
